import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const SHOP_API = `${BASE}/api`;

export const shopApi = axios.create({
  baseURL: SHOP_API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function absoluteShopUrl(relPath) {
  if (!relPath) return "";
  if (relPath.startsWith("http")) return relPath;
  return `${BASE}${relPath}`;
}

export const fetchShopProducts = () => shopApi.get("/shop/products").then((r) => r.data);
export const fetchShopProduct = (slug) => shopApi.get(`/shop/products/${slug}`).then((r) => r.data);
export const createOrder = (payload) => shopApi.post("/shop/orders", payload).then((r) => r.data);
export const createPayment = (orderId) => shopApi.post("/shop/payments/create", { order_id: orderId }).then((r) => r.data);
export const fetchOrder = (orderId) => shopApi.get(`/shop/orders/${orderId}`).then((r) => r.data);
export const fetchMyOrders = () => shopApi.get("/shop/orders").then((r) => r.data);
export const fetchShippingInfo = () => shopApi.get("/shop/shipping-info").then((r) => r.data);

// Mirrors the backend's compute_shipping_fee — highest applicable per-item fee
// wins (product override > category override > default), free above the
// threshold. Used for a live estimate in the checkout UI.
export function computeShippingFee(subtotal, items, shippingInfo) {
  if (!shippingInfo) return 0;
  if (subtotal >= shippingInfo.free_threshold) return 0;
  const list = items || [];
  if (list.length === 0) return shippingInfo.fee;
  const fees = list.map((i) =>
    i.shipping_fee != null ? Number(i.shipping_fee) : (shippingInfo.category_fees || {})[i.category] ?? shippingInfo.fee
  );
  return Math.max(...fees);
}
